"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spotify = void 0;
const react_1 = __importDefault(require("react"));
const Spotify = ({ type, id }) => (react_1.default.createElement("iframe", { style: { borderRadius: '12px' }, src: `https://open.spotify.com/embed/${type}${id}&theme=0`, width: "100%", height: "80", frameBorder: "0", allowFullScreen: true, allow: "autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture", loading: "lazy" }));
exports.Spotify = Spotify;
